import React from "react";
import {
	Container,
	Divider,
	Stack,
	VStack,
	Text,
	Flex,
	Box,
	Link,
	useMediaQuery,
} from "@chakra-ui/react";
import LogoAndSocialIcons from "./components/LogoAndSocial";
import FooterLinks from "./components/FooterLinks";
import ContactForm from "./components/contactForm";

const Footer = () => {

	const [isSmallerScreen] = useMediaQuery("(max-width: 900px)");

	return (
		<Flex>
			<Box as="footer" role="contentinfo" borderTop="1px solid" w="100%" color="muted" bg="smoke">
				<Container w="100%" maxW="100%" py={4} px={isSmallerScreen ? 2 : 4}>
					<Flex
						direction={isSmallerScreen ? "column" : "row"}
						justify="center"
						alignItems="center"
						mb={isSmallerScreen ? 4 : 10}
						spacing={4}
					>
						<LogoAndSocialIcons />
						<FooterLinks />
						<ContactForm />
					</Flex>

					<Divider />
					<Stack justify="center" direction={isSmallerScreen ? "column-reverse" : "row"} align="center" mt={10} textAlign="center">
						<VStack>
							<Text
								spacing="4"
								fontSize="sm"
								color="subtle"
							>
								{"\u00A9"} {new Date().getFullYear()} TaylorFenceNJ.com, All Rights Reserved.
								{/* <br />
							Made with <Box as={FcLike} display="inline" /> by Webify Services. */}
							</Text>
							<br />
							<Text
								fontSize="14px"
								color="black"
								p={4}
								fontWeight={"normal"}
							>
								Made with 💜 by{" "}
								<Link color='purple.800' href="https://webifyservices.com/" isExternal>
									Webify Services
								</Link>
							</Text>
						</VStack>
					</Stack>
				</Container>
			</Box>
		</Flex>
	);
};

export default Footer;
